import { render, staticRenderFns } from "./employeesIncentives.vue?vue&type=template&id=d95ca208"
import script from "./employeesIncentives.vue?vue&type=script&lang=js"
export * from "./employeesIncentives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports